import { apiGetEboletaConfig } from '@/library/api/config';

export default {
	namespaced: true,
	actions:{
    async getConfig({commit}){
      commit('LOADING_CONFIG', true);
      try{
        let resp = await apiGetEboletaConfig();
        commit('SET_CONFIG', resp);
        commit('SET_METODOS_PAGO', resp.metodosPago);
        commit('END_LOADING_CONFIG');
        return resp;
      }catch(err){
        commit('ERROR_LOAD_CONFIG');
        console.error(err);
        throw err;
      }
    },
	},
	mutations:{
    LOADING_CONFIG(state, payload){
      state.estado = 'LOADING';
    },
    ERROR_LOAD_CONFIG(state, payload){
      state.config = 'ERROR'
    },
    SET_CONFIG(state, payload){
      state.config = payload;
    },
    SET_METODOS_PAGO(state, payload){
      state.metodosPago = payload;
    },
    END_LOADING_CONFIG(state){
      state.estado = 'OK';
    },
	},
	getters:{
    loading:(state)=>state.estado === 'LOADING',
    metodosPago:(state)=>(state.metodosPago||[]),
	},
	state:() => ({
    estado: null,
    config: null,
    error: null,
    metodosPago: null,
	}),
}